// extracted by css-extract-rspack-plugin
export default {"heading":"CommentsSection-module__heading__tXjXY"};